const swiperReason = new Swiper(".swiper-reason", {
  loop: true,
  slidesPerView: "auto",
  slidesPerGroup: 1,
  spaceBetween: 20,
  breakpoints: {
    768: {
      loop: false,
      slidesPerView: "auto",
      slidesPerGroup: 1,
      spaceBetween: 40,
    },
  },
  pagination: {
    el: ".reason-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".reason-next",
    prevEl: ".reason-prev",
  },
});
